import { IRecordAboutProps, RecordAbout } from "components/RecordAbout";
import { TopicRecordCounters } from "models/ApiModels";
import * as React from "react";
import { useTranslation } from "react-i18next";

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////

interface IProps extends IRecordAboutProps {
    counters: TopicRecordCounters;
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const TopicAbout: React.FC<IProps> = (props) => {
    const { t } = useTranslation();
    return (
        <RecordAbout
            {...props}
            otherInfo={
                <>
                    <br />
                    <span>{t("Views.Topic.Components.TopicAbout.PublicationText", { count: props.counters.publications })}</span>
                    <br />
                    <span>{t("Views.Topic.Components.TopicAbout.FollowerText", { count: props.counters.followers })}</span>
                </>
            }
        />
    );
};